import { render, staticRenderFns } from "./checkoutDeliveryInfo.vue?vue&type=template&id=5b95b47c"
import script from "./checkoutDeliveryInfo.vue?vue&type=script&lang=js"
export * from "./checkoutDeliveryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports